module.exports = __webpack_public_path__ + "static/media/IMG_7739-min.199407d3.jpg";